import { useContext, useMemo } from "react";

import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import TrialIdentityContext from "src/contexts/data/TrialIdentityContext";
import TrialInstitutionIdentityContext from "src/contexts/data/TrialInstitutionIdentityContext";
import TrialInstitutionSupportingSiteIdentityContext from "src/contexts/data/TrialInstitutionSupportingSiteIdentityContext";
import { createTrialInstitutionSupportingSiteSubMenu } from "src/routing/navigation";

/**
 * Registers the supporting site submenu through the shared layout adapter.
 *
 * Postconditions: A rendered registration requests layout updates after render and removes its
 * submenu code on cleanup. Navigation factories retain responsibility for link metadata.
 * Missing required identities yield no registration. Identity references control recomputation.
 */
const TrialInstitutionSupportingSiteSubMenu: React.FC = () => {
    const { data: trialIdentity } = useContext(TrialIdentityContext);
    const { data: trialInstitutionIdentity } = useContext(TrialInstitutionIdentityContext);
    const { data: supportingSiteIdentity } = useContext(
        TrialInstitutionSupportingSiteIdentityContext
    );

    const subMenu = useMemo(() => {
        if (!trialIdentity || !trialInstitutionIdentity || !supportingSiteIdentity) {
            return null;
        }

        return createTrialInstitutionSupportingSiteSubMenu(
            trialIdentity,
            trialInstitutionIdentity,
            supportingSiteIdentity
        );
    }, [supportingSiteIdentity, trialIdentity, trialInstitutionIdentity]);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default TrialInstitutionSupportingSiteSubMenu;
